exports.iterator = (arreglo) => {
  var siguienteIndice = 0;

  return {
    next: function () {
      return siguienteIndice < arreglo.length
        ? {
            value: arreglo[siguienteIndice++],
            done: false,
            index: siguienteIndice - 1,
          }
        : { done: true };
    },
  };
};

exports.sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
